// safeDate
//
// Return a consistant formatted date for the site

const safeDate = (data) => {

  if(typeof data === 'number') {
    const d = new Date(data*1000);
    const dd = d.getDate()
    const month = d.toLocaleString(undefined, { month: 'long' });
    const yyyy = d.getFullYear()
    const formattedDate = dd + ' ' + month + ' ' + yyyy
    return(formattedDate)
  }
  else {
    if(typeof data === 'string') {
      const ds = Date.parse(data);
      if(ds === NaN){
        return ('')
      }
      else {
        const d = new Date(ds);
        const dd = d.getDate()
        const month = d.toLocaleString(undefined, { month: 'long' });
        const yyyy = d.getFullYear()
        const formattedDate = dd + ' ' + month + ' ' + yyyy
        return(formattedDate)
      }
    }
    else {
      return ('')
    }
  }

}

export { safeDate }

